module.exports = __webpack_public_path__ + "static/media/1012234.7b162cae.jpg";